import * as React from "react";
import NextLink, { LinkProps } from "next/link";

const internalRoutes: RegExp[] = [
  /^\/app\/alerts/,
  /^\/app\/analytics/,
  /^\/app\/history/,
  /^\/app\/notification-settings/,
];

type Props = {
  children: React.ReactNode | string;
  className?: string;
  href: string;
  target?: string;
} & LinkProps;

// Does this route match one of our paths in ./routes.ts?
export function routeIsInApp(href: string): boolean {
  const url = new URL(href, "https://zapier.com");

  // See if we have any matching routes
  return internalRoutes.some((route) => route.test(url.pathname));
}

export const Link = React.forwardRef<HTMLAnchorElement, Props>(
  function Link(props, ref) {
    try {
      // If we are building a link that is local and can be client-side navigated
      // then we build a Next.js compatible <Link>, otherwise return a regular link.

      const isHrefAbsolute = /^(https?:)?\/\//.test(props.href);

      if (routeIsInApp(props.href) && !isHrefAbsolute) {
        return (
          <NextLink legacyBehavior={false} {...props} ref={ref} data-zds />
        );
      }

      // eslint-disable-next-line jsx-a11y/anchor-has-content
      return <a {...props} ref={ref} data-zds />;
    } catch (e) {
      // Return a vanilla link if we encounter an error parsing the provided
      // `href`. At worst this causes a page refresh to the next page but protets
      // against errors occuring.
      // eslint-disable-next-line jsx-a11y/anchor-has-content
      return <a {...props} ref={ref} data-zds />;
    }
  }
);
